import { render, staticRenderFns } from "./ProofreadingItemSelectDialog.vue?vue&type=template&id=cfe9a384&scoped=true"
import script from "./ProofreadingItemSelectDialog.vue?vue&type=script&lang=ts"
export * from "./ProofreadingItemSelectDialog.vue?vue&type=script&lang=ts"
import style0 from "./ProofreadingItemSelectDialog.vue?vue&type=style&index=0&id=cfe9a384&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfe9a384",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cfe9a384')) {
      api.createRecord('cfe9a384', component.options)
    } else {
      api.reload('cfe9a384', component.options)
    }
    module.hot.accept("./ProofreadingItemSelectDialog.vue?vue&type=template&id=cfe9a384&scoped=true", function () {
      api.rerender('cfe9a384', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/dialogs/ProofreadingItemSelectDialog.vue"
export default component.exports